jQuery(document).ready(function($) {
    /*
     * Общие настройки ajax-запросов, отправка на сервер csrf-токена
     */
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    /*
     * Добавление товара в корзину с помощью ajax-запроса без перезагрузки
     */
    $('.picture-modal').click((e) => {
        $('#picture-wrap').html('');
        const img = document.createElement('img');
        img.setAttribute('class', 'picture-source position-absolute');
        $('#picture-wrap').append(img);
        $('.picture-source').attr('src', e.target.dataset.src);
        $('#picture-wrap').css('width', e.target.dataset.width);
        $('#picture-wrap').css('height', e.target.dataset.height);
        $('.picture-source').attr('width', e.target.dataset.width);
        $('.picture-source').attr('height', e.target.dataset.height);
        $('.picture-source').css('left', e.target.dataset.offsetx);
        $('.picture-source').css('top', e.target.dataset.offsety);
        $('#exampleModalLongTitle').html(e.target.dataset.name + ` (${e.target.dataset.manufacturer})`);
        $('a#gotoItem').attr('href', e.target.dataset.url);
        const id = e.target.dataset.id;
        const labels = document.querySelectorAll(`.label-${id}`);
        labels.forEach((item) => {
            const label = document.createElement('div');
            label.setAttribute('class', 'picture-label position-absolute bg-warning');
            label.dataset.label = item.dataset.lable;
            label.setAttribute('style', `left: ${item.dataset.offsetx}px; top: ${item.dataset.offsety}px; cursor: pointer`);
            label.innerHTML = item.dataset.lable;
            $('#picture-wrap').append(label);
        });
    });

    $('.modified').on('click', (e) => {
        const id = e.currentTarget.dataset.modifiedid;
        $('.gallery-image img').attr('src', $(`#modified_image_${id}`).attr('data'));
        document.querySelector('.gallery-image').dataset.currentid = id;
        $('.gallery-background').fadeIn();

    });
    $('.gallery-image').on('click', (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
    });
    $('.gallery-left').on('click', (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        const current_id = parseInt(document.querySelector('.gallery-image').dataset.currentid);
        const count = $('#modified_count').val();
        let id = current_id - 1;
        if (id < 0) id = count - 1;
        if (id >= count) id = 0;
        $('.gallery-image img').attr('src', $(`#modified_image_${id}`).attr('data'));
        document.querySelector('.gallery-image').dataset.currentid = id;
    });
    $('.gallery-right').on('click', (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        const current_id = parseInt(document.querySelector('.gallery-image').dataset.currentid);
        const count = $('#modified_count').val();
        let id = current_id + 1;
        if (id < 0) {
            id = count - 1;
        }
        if (id > count - 1) {
            id = 0;
        }
        $('.gallery-image img').attr('src', $(`#modified_image_${id}`).attr('data'));
        document.querySelector('.gallery-image').dataset.currentid = id;
    });
    $('.gallery-background').on('click', (e) => {
        $('.gallery-background').fadeOut();
    });
    $('.image-close').on('click', () => {
        $('.gallery-background').fadeOut();
    });
});
